import { CSSProperties, ReactNode, useEffect, useState } from "react"
import { classNames, classNamesOrEmpty } from "../../../style/common"
import { CheckboxButtonGroupValue } from "../../../models/Button"

export type CheckboxButtonGroupProps<T = undefined> = {
    onClick: (value: CheckboxButtonGroupValue<T>, state: CheckboxButtonGroupValue<T>[]) => void,
    values: CheckboxButtonGroupValue<T>[],
    disabled?: boolean,
    classNames?: {
        container?: string | undefined,
        button?: string | undefined
    },
    styles?: {
        container?: CSSProperties,
        button?: CSSProperties
    },
    contentGenerator?: (label: string, value: T | undefined) => ReactNode
}

export default function CheckboxButtonGroup<T = undefined>(props: CheckboxButtonGroupProps<T>) {
    const [buttonState, setButtonState] = useState<CheckboxButtonGroupValue<T>[]>(JSON.parse(JSON.stringify(props.values)));

    useEffect(() => {
        setButtonState(JSON.parse(JSON.stringify(props.values)));
    }, [props.values]);

    if (!props.values.length) {
        return <></>;
    }

    const onClick = (index: number) => {
        const newState: CheckboxButtonGroupValue<T>[] = JSON.parse(JSON.stringify(buttonState));
        newState[index].isChecked = !newState[index].isChecked;

        setButtonState(newState);
        props.onClick(newState[index], newState);
    }

    return (
        <div className={`grid grid-cols-3 gap-1 sm:grid-cols-6 ${classNamesOrEmpty(props.classNames?.container)}`}>
            {buttonState.map((value, index) => (
                <button
                    disabled={props.disabled}
                    aria-checked={value.isChecked}
                    key={index}
                    onClick={(event) => onClick(index)}
                    className={
                        classNames(
                            `min-h-[25px] select-none cursor-pointer disabled:cursor-not-allowed focus:outline-none flex items-center justify-center rounded-md py-[2px] px-1 text-xs font-semibold sm:flex-1`,
                            "text-contrast-primary bg-secondary border border-color-border disabled:bg-muted disabled:hover:bg-muted disabled:text-contrast-tertiary disabled:border-none hover:bg-tertiary hover:border-muted aria-checked:bg-emphasis aria-checked:text-emphasis-contrast aria-checked:hover:bg-emphasis-secondary focus:ring-1 focus:ring-emphasis",
                            props.classNames?.button
                        )
                    }
                >
                    {
                        props.contentGenerator
                            ? props.contentGenerator(value.label, value.data)
                            : <span>{value.label}</span>
                    }
                </button>
            ))}
        </div>
    );
}